<template>
  <div class="reply">
    <div class="cont-box">
      <div class="title">
        <Title text="答辩申请" />
        <div>
          <el-form
            ref="search"
            :inline="true"
            :model="condition"
            :rules="searchRules"
            class="search-form"
            slot="search"
            label-width="80px"
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <div>
                  <el-form-item prop="paper_plan_student_id">
                    <el-select
                      v-model="condition.paper_plan_student_id"
                      placeholder="请选择论文计划"
                      clearable
                      filterable
                      style="width: 300px;"
                    >
                      <el-option
                        v-for="item in thesisPlanList"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="loadData">确认</el-button>
                  </el-form-item>
                </div>
              </div>
              <div v-if="isShowDuplicate">
                <div class="btn-box">
                  <div>
                    <el-form-item>
                      <el-button
                        v-if="isShowDuplicateBtn"
                        type="primary"
                        class="link-btn"
                        @click="duplicateCheckClick"
                      >提交申请</el-button>
                    </el-form-item>
                  </div>
                </div>
                <div>
                  <el-form-item>
                    <span>答辩申请截止时间：{{end_apply_time}}</span>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div>
        <el-table
          :data="list"
          headerRowClassName="uni-primary-table-header"
          stripe
          border
        >
          <el-table-column prop="" align="center" label="流程标题">
            <template slot-scope="{row}">
              <span>{{ row.student_title }} + {{ row.process_title }} + {{ row.created_at }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="student_title" align="center" label="学生姓名"></el-table-column> -->
          <el-table-column prop="sign_img" align="center" label="手写签名">
            <template slot-scope="{row}">
              <img :src="row.sign_img" alt="" style="width: 200px;height: 40px;object-fit: contain;">
            </template>
          </el-table-column>
          <el-table-column prop="score_teacher_title" align="center" label="评分老师">
          </el-table-column>
          <!-- <el-table-column prop="check_status_title" align="center" label="申请状态">
          </el-table-column> -->
          <el-table-column prop="result.percentage" align="center" label="查重相似率">
          </el-table-column>
          <!-- <el-table-column prop="paper_score" align="center" label="设计 (论文) 撰写阶段得分">
          </el-table-column> -->
          <el-table-column prop="score_pass_status" align="center" label="设计资料评分状态">
            <template slot-scope="{row}">
              <span>{{ row.score_pass_status | scorePassStatusFliter }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="paper_score" align="center" label="设计资料最终得分">
          </el-table-column>
          <el-table-column prop="remark" align="center" label="评语">
          </el-table-column>
          <el-table-column prop="dup_check_status" align="center" label="查重状态">
            <template slot-scope="{row}">
              <span>{{ row.dup_check_status | dupCheckStatusFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="check_remark" align="center" label="备注">
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="{row}">
              <el-button
                v-if="row.is_redo == 1"
                class="link-btn"
                type="text"
                @click="duplicateCheckClickRedo(row)"
              >重新提交查重文件</el-button>
              <el-button
                v-if="row.is_resubmit == 1"
                class="link-btn"
                type="text"
                @click="resInfoClick(row)"
              >重提设计资料</el-button>
              <el-button
                v-if="row.is_check == 1"
                class="link-btn"
                type="text"
                @click="enterDetection(row)"
              >进入检测</el-button>
              <el-button
                v-if="row.dup_check_status == 1"
                class="link-btn"
                type="text"
                @click="duplicateCheckResClick(row)"
              >查重结果</el-button>
              <el-button
                v-if="row.score_pass_status == 0"
                class="link-btn"
                type="text"
                @click="revokeClick(row)"
              >撤销</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 提交申请 -->
    <el-dialog
      class="duplicateCheck"
      :title="isResubmit ? '重提设计资料' : '提交申请'"
      :visible.sync="isShowDuplicateCheck"
      width="40%"
      @close="duplicateCheckClose"
    >
      <div class="dialog" >
        <el-form
          ref="duplicateCheck"
          :model="duplicateCheckData"
          :rules="duplicateCheckRules"
          label-width="160px"
        >
          <div v-if="professionId == 16 || professionId == 5 || professionId == 13">
            <el-form-item v-if="!isResubmit" label="查重文件：" prop="files_url">
              <FalConUpload
                ref="uploadDuplicateCheck"
                listStyle='text'
                accept=".docx,.doc,.pdf,.txt"
                :limit="1"
                :isFile="true"
                :isAccept="true"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
              ></FalConUpload>
              <!-- <FalConUpload
                ref="uploadDuplicateCheck"
                :multiple="true"
                :limit="20"
                :isShowModal="false"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
              ></FalConUpload> -->
              <div>
                <span class="tips">说明：查重文件只需要上传设计说明,只能上传docx,doc,pdf,txt文件</span>
              </div>
            </el-form-item>
            <el-form-item label="最终设计资料:" prop="files_url2">
              <FalConUpload
                ref="uploadFile"
                listStyle='text'
                accept=""
                :limit='20'
                :multiple="true"
                :isFile="true"
                :isAccept="false"
                @handleRemove="handleRemoveFile"
                @handleChange="handleChangeFile"
              >
              </FalConUpload>
              <div class="tips">说明：将设计的所有资料转换成PDF文化后压缩为ZIP文件上传</div>
            </el-form-item>
          </div>
          <div v-else-if="professionId == 11">
            <el-form-item v-if="!isResubmit" label="查重文件：" prop="files_url">
              <FalConUpload
                ref="uploadDuplicateCheck"
                listStyle='text'
                accept=".docx,.doc,.pdf,.txt"
                :limit="1"
                :isFile="true"
                :isAccept="true"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
              ></FalConUpload>
              <!-- <FalConUpload
                ref="uploadDuplicateCheck"
                :multiple="true"
                :limit="20"
                :isShowModal="false"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
              ></FalConUpload> -->
              <div>
                <span class="tips">说明：只能上传docx,doc,pdf,txt文件,只上传设计论文资料用于查重。设计的程序和演示视频不要上传</span>
              </div>
            </el-form-item>
            <el-form-item label="最终设计资料:" prop="files_url2">
              <FalConUpload
                ref="uploadFile"
                listStyle='text'
                accept=".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                :limit='20'
                :multiple="true"
                :isFile="true"
                :isAccept="false"
                @handleRemove="handleRemoveFile"
                @handleChange="handleChangeFile"
              >
              </FalConUpload>
              <div class="tips">说明：将设计论文、设计程序及演示压缩为ZIP文件上修</div>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="最终设计资料：" prop="files_url">
              <FalConUpload
                ref="uploadDuplicateCheck"
                listStyle='text'
                accept=".docx,.doc,.pdf,.txt"
                :limit="1"
                :isFile="true"
                :isAccept="true"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
              ></FalConUpload>
              <!-- <FalConUpload
                ref="uploadDuplicateCheck"
                :multiple="true"
                :limit="20"
                :isShowModal="false"
                @handleRemove="duplicateCheckHandleRemove"
                @handleChange="duplicateCheckHandleChange"
              ></FalConUpload> -->
              <div>
                <span class="tips">说明：只能上传docx,doc,pdf,txt文件</span>
              </div>
            </el-form-item>
            <!-- <el-form-item label="最终设计资料:" prop="files_url2">
              <FalConUpload
                ref="uploadFile"
                listStyle='text'
                accept=".pdf,.zip,.rar,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                :limit='20'
                :multiple="true"
                :isFile="true"
                :isAccept="false"
                @handleRemove="handleRemoveFile"
                @handleChange="handleChangeFile"
              >
              </FalConUpload>
              <div class="tips">说明：可上传PDF文档，压缩文件或OFFICE文档</div>
            </el-form-item> -->
          </div>
          <el-form-item v-if="!isResubmit" label="手写签名:" prop="sign_img">
            <esignHandle
              ref="duplicateCheckEsignHandle"
              :selectSignImg.sync="duplicateCheckData.sign_img"
            ></esignHandle>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center">
        <el-button @click="isShowDuplicateCheck = false">取 消</el-button>
        <el-button type="primary" :loading="duplicateCheckLoading" @click="duplicateCheckSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 重新提交查重文件-->
    <el-dialog
      class="duplicateCheckRedo"
      title="重新提交查重文件"
      :visible.sync="isShowDuplicateCheckRedo"
      width="40%"
      @close="duplicateCheckCloseRedo"
    >
      <div class="dialog" >
        <el-form
          ref="duplicateCheckRedo"
          :model="duplicateCheckRedoData"
          :rules="duplicateCheckRedoRules"
          label-width="160px"
        >
          <el-form-item label="查重文件：" prop="files_url">
            <FalConUpload
              ref="uploadDuplicateCheckRedo"
              listStyle='text'
              accept=".docx,.doc,.pdf,.txt"
              :limit="1"
              :isFile="true"
              :isAccept="true"
              @handleRemove="duplicateCheckHandleRemoveRedo"
              @handleChange="duplicateCheckHandleChangeRedo"
            ></FalConUpload>
            <div>
              <span class="tips">说明：查重文件只需要上传设计说明,只能上传docx,doc,pdf,txt文件</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center">
        <el-button @click="isShowDuplicateCheckRedo = false">取 消</el-button>
        <el-button type="primary" :loading="duplicateCheckLoadingRedo" @click="duplicateCheckSubmitRedo">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查重结果 -->
    <el-dialog
      class="duplicateCheckRes"
      title="查重结果"
      :visible.sync="isShowDuplicateCheckRes"
      width="40%"
      @close="duplicateCheckResClose"
    >
      <div class="dialog" >
        <span v-if="!duplicateRes.paperguid" class="tips">暂无结果</span>
        <el-scrollbar v-else style="height: 300px;">
            <div class="item">
                <span class="name">检测报告编码：</span>
                <span class="value">{{ duplicateRes.paperguid }}</span>
            </div>
            <div class="item">
                <span class="name">检测文章标题：</span>
                <span class="value">{{ duplicateRes.papertitle }}</span>
            </div>
            <div class="item">
                <span class="name">相似率：</span>
                <span class="value">{{ duplicateRes.percentage }}</span>
            </div>
            <div class="item">
                <span class="name">检测时间：</span>
                <span class="value">{{ duplicateRes.checkdate }}</span>
            </div>
            <div class="item">
                <span class="name">检测字数：</span>
                <span class="value">{{ duplicateRes.paperword }}</span>
            </div>
            <div class="item">
                <span class="name">在线预览链接：</span>
                <span class="value">
                    <a :href="duplicateRes.paperviewurl" target="_blank">{{ duplicateRes.paperviewurl }}</a>
                </span>
            </div>
            <div class="item">
                <span class="name">下载报告地址：</span>
                <span class="value">
                    <a :href="duplicateRes.paperdownurl" target="_blank">{{ duplicateRes.paperdownurl }}</a>
                </span>
            </div>
        </el-scrollbar>
      </div>
      <div style="text-align: center">
        <el-button @click="isShowDuplicateCheckRes = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  adultStudentPpsUpDuplicate,
  adultStudentPpsUpDuplicateRedo,
  adultStudentPpAll,
  adultStudentPpsDuplicate,
  studentPpsDuplicateUrl,
  ppsRevokeDuplicate,
  ppsReDuplicate,
} from "@/api/graduation";
import FalConUpload from "@/components/uploadFile";
import { putObject, uploadFiles, deleteObject } from "@/utils/upload";

import esignHandle from '@/components/esignHandle';

import {arrAttDel, deepClone} from '@/utils/func';

import {downladUrl} from '@/utils/func';

export default {
  name: "reply",
  components: { FalConUpload, esignHandle },
  filters: {
    // 查重状态
    dupCheckStatusFilter(v){
      const obj = {
        0: '未开始',
        1: '已通过',
        2: '未通过',
      };
      return obj[v];
    },
    // 设计资料评分状态
    scorePassStatusFliter(v) {
      const obj = {
        0: '评分中',
        1: '已通过',
        2: '未通过',
      };
      return obj[v];
    },
    // 查重附加审核状态
    duplicateStatusFilter(v){
      const obj = {
        0: '待检测',
        1: '已通过',
        2: '未通过',
      };
      return obj[v];
    },
    // 查重附件审核状态 样式
    duplicateStatusStyle(v){
      const obj = {
        0: '',
        1: 'success',
        2: 'danger',
      };
      return obj[v];
    },
  },
  data() {
    return {
      condition: {
        paper_plan_student_id: '',  //论文计划
      },
      searchRules: {
        paper_plan_student_id: [{ required: true, message: "请选择论文计划", trigger: "change" }],
      },
      thesisPlanList: [],  //论文计划列表
      isShowDuplicateBtn: true,  //显示提交申请按钮
      isShowDuplicateCheckRecordBtn: true,  //显示查重记录按钮

      isShowDuplicate: false,  //选择论文计划后出现的数据

      list:[],
      listTotal: -1,


      // 提交申请
      isShowDuplicateCheck: false,
      isShowDuplicateCheckRedo: false,
      duplicateCheckData: {
        paper_plan_student_id: '',  //设计资料id
        files_url: '',  //查重文件
        files_url2: '',  //最终设计资料 文件
        sign_img: '',  //签名图片
      },
      duplicateCheckRules: {
        files_url: [{ required: true, trigger: 'change', message: "请上传查重文件" }],
        files_url2: [{ required: true, trigger: 'change', message: "请上传最终设计资料文件" }],
        sign_img: [{ required: true, trigger: 'change', message: "请上传签名图片" }],
      },
      duplicateCheckRedoData: {
        paper_plan_student_id: '',  //设计资料id
        paper_process_id: '',  //查重记录id
        files_url: '',  //查重文件
      },
      duplicateCheckRedoRules: {
        files_url: [{ required: true, trigger: 'change', message: "请上传查重文件" }],
      },


      //查重结果
      isShowDuplicateCheckRes: false,
      duplicateRes: {
          paperguid: '',  //检测报告编码
          papertitle: '',  //检测文章标题
          percentage: '',  //相似率
          checkdate: '',  //检测时间
          paperword: '',  //检测字数
          paperviewurl: '',  //在线预览链接
          paperdownurl: '', //下载报告地址
      },

      duplicateCheckLoading: false,  //弹窗 提交申请 加载
      duplicateCheckLoadingRedo: false,  //弹窗 提交申请 加载

      end_apply_time: '',  //答辩申请截止时间

      professionId: null,  //保存选中值得课程id

      isResubmit: false,  //是否重新提交
      resInfoData: {
        paper_process_id: '',  
        files_url: '',
      },

    };
  },
  created() {
    // this.getListFn();
    this.getThesisPlanList();
  },
  methods: {
    // 重提设计资料
    resInfoClick(row){
      this.resInfoData.paper_process_id = row.id;
      this.isShowDuplicateCheck = true;
      this.isResubmit = row.is_resubmit == 1;
    },
    // 点击撤销
    revokeClick(row){
      this.$confirm("确定撤销本次申请吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const data = {
          id: row.id,
        };
        ppsRevokeDuplicate(data).then(async res => {
          this.$message.success('操作成功');
          await this.getThesisPlanList();
          this.loadData();
        });
      });
    },
    // 点击进去检测
    enterDetection(row){
      let data = {
        paper_cnki_id: row.result.id,
      };
      studentPpsDuplicateUrl(data).then(res => {
        if(res.code == 200){
          window.open(res.result.redirect_url, '_blank');
        }
      });
    },
    // 点击查重结果
    duplicateCheckResClick(item){
      this.duplicateRes = item.result;
      this.isShowDuplicateCheckRes = true;
    },
    // 弹窗 查重结果 关闭
    duplicateCheckResClose(){
      this.isShowDuplicateCheckRes = false;
      this.duplicateRes = {
          paperguid: '',  //检测报告编码
          papertitle: '',  //检测文章标题
          percentage: '',  //相似率
          checkdate: '',  //检测时间
          paperword: '',  //检测字数
          paperviewurl: '',  //在线预览链接
          paperdownurl: '', //下载报告地址
      };
    },
    // 弹窗 查看问答 文件下载
    downloadFiles(row){
      downladUrl(row.url, row.name);
    },
    // 选择资料确认
    loadData(){
      this.$refs["search"].validate((valid) => {
        if (valid) {
          this.getListFn();
          let curItem = this.thesisPlanList.find(item => item.id === this.condition.paper_plan_student_id);
          this.isShowDuplicateBtn = curItem.process_status < 3;
          this.isShowDuplicateCheckRecordBtn = curItem.is_devise_submit == 1;
          this.end_apply_time = curItem.end_apply_time;
          this.professionId = curItem.profession_id;
        }
      });
    },
    // 获取论文计划
    getThesisPlanList(){
      return new Promise((resolve,reject) => {
        adultStudentPpAll().then(res => {
          this.thesisPlanList = res.result;
          resolve(res);
        });
      });
    },
    // 弹窗 提交申请 提交
    duplicateCheckSubmit(){
      this.$refs["duplicateCheck"].validate(async (valid) => {
        if (valid) {
          this.duplicateCheckLoading = true;
          let queryData = {
              paper_process_id: this.resInfoData.paper_process_id,
          };
          // 是否重提设计资料
          if(this.isResubmit){
            switch(this.professionId){
              case 11:
              case 16:
              case 5:
              case 13:
                let upload;
                if(this.duplicateCheckData.files_url2){
                  upload = new Promise((resolve, reject) => {
                    uploadFiles(this.duplicateCheckData.files_url2, (urls) => {
                      resolve(urls);
                    }, null, 'student', '', true);
                  });
                }
                queryData.files_url = await upload;
                break;
              default:
                let upload2;
                if(this.duplicateCheckData.files_url){
                  upload2 = new Promise((resolve, reject) => {
                    uploadFiles(this.duplicateCheckData.files_url, (urls) => {
                      resolve(urls);
                    }, null, 'student', '', true);
                  });
                }
                queryData.files_url = await upload2;
                break;
            }
            ppsReDuplicate(queryData).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功');
                this.isShowDuplicateCheck = false;
                // window.open(res.result.redirect_url, '_blank');
                // await this.getThesisPlanList();
                this.loadData();
              }
            }).finally(() => {
              this.duplicateCheckLoading = false;
            });
          }else{
            switch(this.professionId){
              case 11:
              case 16:
              case 5:
              case 13:
                let upload1;
                let upload2;
                if(this.duplicateCheckData.files_url){
                  upload1 = new Promise((resolve, reject) => {
                    uploadFiles(this.duplicateCheckData.files_url, (urls) => {
                      resolve(urls);
                    }, null, 'student', '', true);
                  });
                }
                if(this.duplicateCheckData.files_url2){
                  upload2 = new Promise((resolve, reject) => {
                    uploadFiles(this.duplicateCheckData.files_url2, (urls) => {
                      resolve(urls);
                    }, null, 'student', '', true);
                  });
                }
                let urlList = await Promise.all([upload1, upload2]);
                let data = deepClone(this.duplicateCheckData);
                let files_url = JSON.parse(urlList[0]);
                let finalDesignFiles = JSON.parse(urlList[1]);
                data.files_url = JSON.stringify(files_url.map(item => {
                  item.finalDesignFiles = finalDesignFiles;
                  return item;
                }));
                queryData = {
                  paper_plan_student_id: data.paper_plan_student_id,
                  files_url: data.files_url,
                  sign_img: data.sign_img,
                };
                break;
              default:
                let files_url2;
                let upload3;
                let data2 = deepClone(this.duplicateCheckData);
                if(this.duplicateCheckData.files_url){
                  upload3 = new Promise((resolve, reject) => {
                    uploadFiles(this.duplicateCheckData.files_url, (urls) => {
                      resolve(urls);
                    }, null, 'student', '', true);
                  });
                }
                files_url2 = await upload3;
                if(files_url2){
                  data2.files_url = JSON.stringify(JSON.parse(files_url2).map(item => {
                    item.finalDesignFiles = JSON.parse(files_url2);
                    return item;
                  }));
                }
                queryData = {
                  paper_plan_student_id: data2.paper_plan_student_id,
                  files_url: data2.files_url,
                  sign_img: data2.sign_img,
                };
                break;
            }
            adultStudentPpsUpDuplicate(queryData).then(async res => {
              if(res.code == 200){
                this.$message.success('保存成功');
                this.isShowDuplicateCheck = false;
                // window.open(res.result.redirect_url, '_blank');
                await this.getThesisPlanList();
                this.loadData();
              }
            }).finally(() => {
              this.duplicateCheckLoading = false;
            });
          }
          
        }
      })
    },

    // 弹窗 提交申请 提交
    duplicateCheckSubmitRedo(){
      this.$refs["duplicateCheckRedo"].validate(async (valid) => {
        if (valid) {
          this.duplicateCheckLoadingRedo = true;
          let queryData;
          let upload1;
          let data = deepClone(this.duplicateCheckRedoData);
          if(this.duplicateCheckRedoData.files_url){
            upload1 = new Promise((resolve, reject) => {
              uploadFiles(this.duplicateCheckRedoData.files_url, (urls) => {
                resolve(urls);
              }, null, 'student', '', true);
            });
          }

          data.files_url = await upload1;
          console.log(data)

          queryData = {
            paper_plan_student_id: data.paper_plan_student_id,
            files_url: data.files_url,
            paper_process_id: data.paper_process_id,
          };

          adultStudentPpsUpDuplicateRedo(queryData).then(async res => {
            if(res.code == 200){
              this.$message.success('保存成功');
              this.isShowDuplicateCheckRedo = false;
              // window.open(res.result.redirect_url, '_blank');
              await this.getThesisPlanList();
              this.loadData();
            }
          }).finally(() => {
            this.duplicateCheckLoadingRedo = false;
          });
        }
      })
    },
    // 弹窗 提交申请 查重文件 删除
    duplicateCheckHandleRemove(data){
      this.duplicateCheckData.files_url = data.fileList;
    },
    // 弹窗 提交申请 查重文件 删除
    duplicateCheckHandleRemoveRedo(data){
      this.duplicateCheckRedoData.files_url = data.fileList;
    },
    // 弹窗 提交申请 查重文件 多传
    duplicateCheckHandleChange(data){
      this.duplicateCheckData.files_url = data.fileList;
    },
    // 弹窗 提交申请 查重文件 多传
    duplicateCheckHandleChangeRedo(data){
      this.duplicateCheckRedoData.files_url = data.fileList;
    },
    // 弹窗 提交申请 上传 最终设计资料文件
    handleChangeFile(data) {
      this.duplicateCheckData.files_url2 = data.fileList;
    },
    // 弹窗 提交申请 删除 最终设计资料文件
    handleRemoveFile(data) {
      this.duplicateCheckData.files_url2 = data.fileList;
    },
    // 弹窗 提交申请 关闭
    duplicateCheckClose(){
      this.duplicateCheckData = {
        defense_process_id: '',  //设计资料id
        files_url: '',  //查重文件
        files_url2: '',  //最终设计资料 文件
        sign_img: '',  //签名图片
      };
      if(this.$refs['uploadDuplicateCheck']) this.$refs['uploadDuplicateCheck'].reset();
      if(this.$refs['uploadFile']) this.$refs['uploadFile'].reset();
      this.$refs['duplicateCheckEsignHandle'].handleReset();  //签名这块清空
      this.$nextTick(() => {
        this.$refs["duplicateCheck"].clearValidate();
      });
    },
    // 弹窗 提交申请 关闭
    duplicateCheckCloseRedo(){
      this.duplicateCheckData = {
        defense_process_id: '',  //设计资料id
        files_url: '',  //查重文件
      };
      if(this.$refs['uploadDuplicateCheckRedo']) this.$refs['uploadDuplicateCheckRedo'].reset();
      this.$nextTick(() => {
        this.$refs["duplicateCheckRedo"].clearValidate();
      });
    },
    duplicateCheckClickRedo(row){
      this.duplicateCheckRedoData.paper_plan_student_id = this.condition.paper_plan_student_id;
      this.isShowDuplicateCheckRedo = true;
      this.duplicateCheckRedoData.paper_process_id = row.id;
    },
    // 点击 提交申请
    duplicateCheckClick(){
      this.duplicateCheckData.paper_plan_student_id = this.condition.paper_plan_student_id;
      this.isShowDuplicateCheck = true;
    },
    // 获取数据
    getListFn(){
      let data = {
        paper_plan_student_id: this.condition.paper_plan_student_id
      };
      adultStudentPpsDuplicate(data).then(res => {
        if(res.code == 200){
          this.list = res.result;
          this.isShowDuplicate = true;
        }
      });
    },
  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss">
.reply{
  .el-scrollbar{
    padding-bottom: 20px;
    .el-scrollbar__wrap{
      overflow-x: hidden;  // 隐藏自带的滚动条
    }
  }
}
</style>

<style lang="scss" scoped>
.reply {
  min-height: $contentH;
  padding: $sideMargin;
  padding-bottom: 0;
  .cont-box{
    background: $white;
    min-height: inherit;
    padding: 0 20px 20px;
    .title{
      .btn-box{
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .tips{
    font-size: 12px;
    color: #999;
  }
  .duplicateCheckRes{
    .item{
      padding: 5px 0;
      .name{
        font-weight: bold;
      }
    }
  }
}
</style>
